var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Company } from 'packages/company/entities/Company';
import { CompanyRepository } from 'packages/company/CompanyRepository';
import RippleButton from 'common/UIToolKit/controls/Button.vue';
import UiTextInput from 'ui/v1/controls/UiTextInput.vue';
import UiPaginationControls from 'ui/v1/controls/UiPaginationControls.vue';
import Component from 'vue-class-component';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import Icon from 'common/UIToolKit/Icon.vue';
import { container } from 'tsyringe';
import { Pagination } from 'packages/core/Pagination';
import { EntityBuilder } from '@decahedron/entity';
import BallLoader from 'ui/v1/loaders/BallLoader.vue';
import { CompanyService } from 'packages/company/CompanyService';
import { Getter, namespace } from 'vuex-class';
import { remove } from 'lodash';
import Permissions from 'common/support/Permissions';
import { Watch } from 'vue-property-decorator';
import { checkPermission } from 'packages/authorization/permission-check';
var companyModule = namespace('companyModule');
var CompanySwitcherFlyout = /** @class */ (function (_super) {
    __extends(CompanySwitcherFlyout, _super);
    function CompanySwitcherFlyout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companySearchQuery = '';
        _this.companies = [];
        _this.loading = false;
        _this.totalCompanies = 0;
        _this.perPage = 10;
        _this.pagination = EntityBuilder.buildOne(Pagination, {
            perPage: _this.perPage,
        });
        _this.companyService = new CompanyService();
        _this.companyRepository = container.resolve(CompanyRepository);
        _this.authenticator = container.resolve(Authenticator);
        _this.permissions = container.resolve(Permissions);
        _this.companyAccessPermissions = {};
        return _this;
    }
    Object.defineProperty(CompanySwitcherFlyout.prototype, "companyId", {
        get: function () {
            return this.currentCompanyId || this.authenticator.getSelectedCompany();
        },
        enumerable: false,
        configurable: true
    });
    CompanySwitcherFlyout.prototype.update = function () {
        var _this = this;
        this.loading = true;
        this.companyRepository
            .search(this.companySearchQuery, this.pagination)
            .then(function (response) {
            _this.companies = response.items;
            _this.pagination = response.pagination;
            _this.totalCompanies = response.pagination.total;
            if (_this.currentCompanyId) {
                remove(_this.companies, function (x) { return x.id === _this.currentCompanyId; });
            }
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    CompanySwitcherFlyout.prototype.created = function () {
        this.getCompany(this.companyId);
        this.update();
    };
    CompanySwitcherFlyout.prototype.mounted = function () {
        this.focusSearchField();
    };
    CompanySwitcherFlyout.prototype.checkAuthorizationForCompanies = function () {
        var _this = this;
        if (!this.permissions.isJobillaUser) {
            return;
        }
        var companiesToLoadPermissionsFor = this.companies.filter(function (company) { return !(company.id in _this.companyAccessPermissions); });
        companiesToLoadPermissionsFor.forEach(function (company) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        Vue.set(this.companyAccessPermissions, company.id, 'loading');
                        _b = (_a = Vue).set;
                        _c = [this.companyAccessPermissions, company.id];
                        return [4 /*yield*/, checkPermission('view', 'company', company.id)];
                    case 1:
                        _b.apply(_a, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CompanySwitcherFlyout.prototype.search = function (event) {
        if (this.companySearchQuery !== '' && event.type === 'submit') {
            this.pagination.currentPage = 1;
        }
        this.update();
    };
    CompanySwitcherFlyout.prototype.switchCompany = function (company) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.authenticator.selectCompany(company.id);
                window.location.href = "/c/" + company.id;
                return [2 /*return*/];
            });
        });
    };
    CompanySwitcherFlyout.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.companySearchQuery = '';
                        this.pagination = EntityBuilder.buildOne(Pagination, { perPage: this.perPage });
                        return [4 /*yield*/, this.search()];
                    case 1:
                        _a.sent();
                        this.focusSearchField();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanySwitcherFlyout.prototype.focusSearchField = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$refs.searchInput) {
                _this.$refs.searchInput.focus();
            }
        });
    };
    var _a;
    __decorate([
        Getter,
        __metadata("design:type", Number)
    ], CompanySwitcherFlyout.prototype, "currentCompanyId", void 0);
    __decorate([
        companyModule.State,
        __metadata("design:type", typeof (_a = typeof Company !== "undefined" && Company) === "function" ? _a : Object)
    ], CompanySwitcherFlyout.prototype, "company", void 0);
    __decorate([
        companyModule.Action,
        __metadata("design:type", Function)
    ], CompanySwitcherFlyout.prototype, "getCompany", void 0);
    __decorate([
        Watch('companies'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CompanySwitcherFlyout.prototype, "checkAuthorizationForCompanies", null);
    CompanySwitcherFlyout = __decorate([
        Component({
            components: {
                RippleButton: RippleButton,
                UiTextInput: UiTextInput,
                UiPaginationControls: UiPaginationControls,
                Icon: Icon,
                BallLoader: BallLoader,
            },
        })
    ], CompanySwitcherFlyout);
    return CompanySwitcherFlyout;
}(Vue));
export default CompanySwitcherFlyout;
